/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { JobCompleteDto } from '../../models/job-complete-dto';

export interface WorkerControllerCompleteJob$Params {
  jobUuid: string;
      body: JobCompleteDto
}

export function workerControllerCompleteJob(http: HttpClient, rootUrl: string, params: WorkerControllerCompleteJob$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, workerControllerCompleteJob.PATH, 'post');
  if (params) {
    rb.path('jobUuid', params.jobUuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

workerControllerCompleteJob.PATH = '/worker/jobs/{jobUuid}/complete';
